module.exports = __webpack_public_path__ + "static/media/hero.92d5ca59.jpg";